
import React , { useState , useEffect } from 'react'
import Container from '@mui/material/Container';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import MuiAlert from '@mui/material/Alert';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Paper from '@mui/material/Paper';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';

//
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';

function Rubros() {
    const [mensaje, setMensaje] = React.useState('');
    const [openMsgError, setOpenMsgError] = React.useState(false);
    const [comercios,setComercios] = useState([]);
    const [rubros,setRubros] = useState([]);
    const [archivo6, setArchivo6] = useState('');
    const[titulo,setTitulo] = useState('');
    const [open, setOpen] = React.useState(false);

    const handleEstadoClick = async (id,rz,titulo) => {
        // ventana modificacion  
     //     if (titulo === 'Aprueba') {
        //      setEstado(true);
    //        }
    //      else
      //        {setEstado(false);
    } 

    const handleCloseMsgError = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenMsgError(false);
      };
      const handleNuevoClose = () => {
    //    setOpenNuevo(false);
      };
    
      const handleClose = () => {
   //     setOpen(false);
      };
      //
      const handleEstadoClose = () => {
   //     setOpenEstado(false);
      };
    
      const handleClickMsg = () => {
  //      setOpenMsgOk(true);
      };
      const handleCloseMsg = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
   //     setOpenMsgOk(false);
      };

      const handleSubmit6 = async (event) => {
        event.preventDefault();

        
        const formData = new FormData();
        formData.append('sampleFile', archivo6);
//        formData.append('provincia',selectedOptionProvincia);
 //       formData.append('localidad',selectedOptionLocalidad);
        //console.log(selectedOptionProvincia , selectedOptionLocalidad)
            //
            try {
                const baseURL = process.env.REACT_APP_SERVER_PATH + 'logo/6';
                const res = await fetch(`${baseURL}`, {
                  method: "POST",
                  body: formData,
                });
      
                if (res.status === 200) {
                  setTitulo('Información');
                  setMensaje('Envio correcto')
                   setOpen(true);
                  
                } else
                if (res.status === 500) 
                 {
                  setTitulo('Error');
                  setMensaje('Error al enviar el archivo')
                   setOpen(true);
                 }
  
                    } catch (err) {
                      setTitulo('Error');
                      setMensaje('Error al enviar el archivo')
                      setOpen(true);
                      //console.log(err.message)
              }
            //
      };
      
      const handleFileChange6 = (event) => {
        setArchivo6(event.target.files[0]);
      };

      const getRubros = () => {
        const baseURL = process.env.REACT_APP_SERVER_PATH+'rubrostodos';
        fetch(`${baseURL}`)
        .then(res => res.json())
        .then(
          (result) => { setRubros(result) 
          },
          (error) => {
          }
        )
       }
       useEffect(() => {  

        getRubros();
        // eslint-disable-next-line    
    },[])

  return (
    <>
     <Container component="main" maxWidth="lg">
       <h2>Rubros</h2>
        <TableContainer component={Paper}  sx = {{mt : 2}}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            < TableHead>
                <TableRow>
                    <TableCell >ID</TableCell >
                    <TableCell >Descripción</TableCell >
                    <TableCell >Acciones</TableCell >
                </TableRow>
            </ TableHead>
            <TableBody>
            {rubros.map((item) => (
            <TableRow
              key={item.idrubro}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell >{item.idrubro}</TableCell >
              <TableCell >{item.detalle}</TableCell >
              <TableCell >
                <Button color="info" variant="contained" startIcon={<AddIcon />} 
                //onClick={() => handleDeleteClick(item.idcentrocomercial,item.descripcion)}
                >Agregar LOGO</Button>
                
              </TableCell >
              <TableCell >
                <Button color="secondary" variant="contained" startIcon={<SaveIcon />} 
                //onClick={() => handleDeleteClick(item.idcentrocomercial,item.descripcion)}
                >Guardar</Button>
              </TableCell >              </TableRow>
          ))}          
        </TableBody>
      </Table>
      </TableContainer>
   { /*
       
     
      <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={openMsgOk} autoHideDuration={6000} onClose={handleCloseMsg}>
        <Alert onClose={handleCloseMsg} severity="success" sx={{ width: '100%' }}>
          {mensaje}
        </Alert>
      </Snackbar>
    </Stack>

    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={openMsgError} autoHideDuration={6000} onClose={handleCloseMsgError}>
        <Alert onClose={handleCloseMsgError} severity="error" sx={{ width: '100%' }}>
        {mensaje}
        </Alert>
      </Snackbar>
    </Stack>
        */}
    </Container>
    </>
  )
}

export default Rubros